module.exports = __webpack_public_path__ + "static/media/IMG_2025-min.7e0b6f96.JPG";